import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';
import {createLecturer} from '../../../../../../redux/timetable/timetableActions';
import {getEid} from '../../../../../../redux/event/eventActions';
import {uploadFile} from '../../../../../../redux/user/userActions';
import {isBase64Url} from '../../../../../../functions/isBase64Url';
import {TLecturer} from '../../../../../../redux/timetable/timetable.type';
import {Values} from './types';

export const submitLecturer = async (
    values: Values,
    close: () => void,
) => {
    let image: string | null = null;
    if(values.image && values.image !== teamMemberPhoto) {
        image = isBase64Url(values.image)
            ? await uploadFile(values.image, '', 'lecturer', getEid())
            : values.image;
    }

    const payload: Omit<TLecturer, 'lid'> = {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        email: values.email.trim() || null,
        phone: values.phone.trim() || null,
        image,
    };
    await createLecturer(payload);
    close();
};
